<template>
  <div class="main-content-container bg--light pb-2">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span class="text-uppercase font-family-medium">Customers</span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <h1 class="font-lg font-family-medium primary-dark content-title">
        {{ isOwnerUser ? "Customers" : "Dedicated" }}
      </h1>

      <div
        class="position-absolute grid-icon-container"
        v-if="loaded && customersList.length"
      >
        <img
          v-if="!showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_grid.svg"
          alt
          class="cursor-pointer"
        />
        <img
          v-if="showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_list.svg"
          alt
          class="cursor-pointer"
        />
      </div>
      <b-dropdown-divider class="mb-5 mt-3 " />
    </div>

    <div v-if="!showListView" class="d-flex grid-card-wrapper">
      <b-row class="w-100 d-flex flex-column" no-gutters>
        <b-row>
          <b-col
            cols="6"
            md="4"
            lg="4"
            xl="3"
            v-for="customer in customersList"
            :key="customer.customer.profile.id"
          >
            <b-card
              no-body
              @click="navigate(customer.customer.profile)"
              @mouseenter="showCardHover(customer.customer.profile.id)"
              @mouseleave="undoCardHover(customer.customer.profile.id)"
              class="grid-card mb-5 p-3"
            >
              <div class="d-flex justify-content-end">
                <div class="d-flex" v-if="!isOwnerUser">
                  <div
                    v-if="
                      !archiveHover ||
                        (showInactiveArchiveHover &&
                          activeArchiveHoverId !== customer.customer.profile.id)
                    "
                    class="empty-icon-avatar d-flex align-items-center justify-content-center"
                  >
                    <img
                      class="cursor-pointer"
                      @click.stop="showArchiveModal(customer.customer.profile)"
                      src="@/assets/icons/arrow_down_square.svg"
                      alt
                    />
                  </div>
                  <div
                    class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                    v-if="
                      archiveHover &&
                        activeArchiveHoverId === customer.customer.profile.id
                    "
                    @click.stop="showArchiveModal(customer.customer.profile)"
                  >
                    <img
                      src="@/assets/icons/arrow_down_square_hover.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <b-card-body class="text-center grid-card-body position-relative">
                <b-button
                  v-if="!customer.customer.profile.isProfileIntakeSubmitted"
                  class="btn-danger btn-pill notification-btn-grid btn-align-top position-absolute new-tag"
                  >New</b-button
                >
                <div class="grid-card-avatar-wrapper">
                  <b-avatar
                    class="customers-grid-avatar"
                    v-if="customer.customer.profile.user.avatarThumbnail"
                    size="12rem"
                    :src="customer.customer.profile.user.avatarThumbnail"
                  ></b-avatar>
                  <b-avatar
                    class="bg--primary customers-grid-avatar"
                    v-else
                    size="12rem"
                    :text="customerInitials(customer.customer.profile.user)"
                  ></b-avatar>
                  <div class="open-tasks-indicator font-size-sm" v-b-tooltip :title="`Number of open tasks: ${customer.customer.profile.customerProfile.openTasksCount}`">
                    {{ customer.customer.profile.customerProfile.openTasksCount }}
                  </div>
                </div>
                <p class="font-family-medium primary--text mt-4" :title="customerFullName(customer.customer.profile.user)">
                  {{ ellipsify(customerFullName(customer.customer.profile.user), 25) }}
                </p>
                <div class="d-flex justify-content-center reduce-whitespace-2">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{
                      customer.customer.profile.customerProfile.membership.title || 'N/A'
                    }}</b-button
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <infinite-loading
          spinner="spiral"
          @infinite="infiniteHandlerDedicatedCustomers"
          :identifier="infiniteId"
          ><div slot="no-more">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div>
          <div slot="no-results">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div></infinite-loading
        >
      </b-row>
    </div>
    <b-row v-if="showListView" no-gutters class='heading-row'>
      <b-col cols="12" xl="6">
        <b-row class="mx-0 justify-content-between">
          <b-col class="">
            <h6 class="primary--text font-family-medium font-sm">Customer</h6>
          </b-col>
          <b-col cols="6" class="" :style="{textAlign:'right'}"> 
            <h6 class="primary--text font-family-medium font-sm">Actions</h6>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6" class="second-heading-column">
        <b-row class="mx-0 justify-content-between">
          <b-col class="">
            <h6 class="primary--text font-family-medium font-sm">Customer</h6>
          </b-col>
          <b-col cols="6" class="" :style="{textAlign:'right'}"> 
            <h6 class="primary--text font-family-medium font-sm">Actions</h6>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="showListView" class="mb-4" no-gutters>
      <b-col
        class="grid-list-column"
        md="12"
        xl="6"
        lg="12"
        sm="12"
        cols="12"
        v-for="customer in customersList"
        :key="customer.customer.profile.id"
      >
        <b-card
          @click="navigate(customer.customer.profile)"
          @mouseleave="undoCardHover(customer.customer.profile.id)"
          @mouseenter="showCardHover(customer.customer.profile.id)"
          class="grid-list-card"
          no-body
        >
          <b-card-body class="d-flex text-center grid-list-card-body">
            <b-row no-gutters class="w-100">
              <b-col cols="7" class="d-flex">
                <div class="grid-card-avatar-wrapper list-view">
                  <b-avatar
                    v-if="customer.customer.profile.user.avatarThumbnail"
                    class="customers-grid-avatar"
                    size="8rem"
                    :src="customer.customer.profile.user.avatarThumbnail"
                  ></b-avatar>
                  <b-avatar
                    v-else
                    size="8rem"
                    class="customers-grid-avatar bg--primary"
                    :text="customerInitials(customer.customer.profile.user)"
                  ></b-avatar>
                  <div class="open-tasks-indicator font-size-sm" v-b-tooltip :title="`Number of open tasks: ${customer.customer.profile.customerProfile.openTasksCount}`">
                    {{ customer.customer.profile.customerProfile.openTasksCount }}
                  </div>
                </div>
                <div
                  class="d-flex flex-column align-items-start justify-content-center ml-4 customer-data-wrapper"
                >
                  <p class="font-family-medium primary--text">
                    {{
                      `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                    }}
                  </p>
                  <p class="secondary--text customer-email">
                    {{ `${customer.customer.profile.user.email}` }}
                  </p>
                  <div class="d-flex justify-content-center">
                    <b-button
                      class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                      >{{
                        customer.customer.profile.customerProfile.membership.title || 'N/A'
                      }}
                    </b-button>
                  </div>
                </div>
              </b-col>
              <b-col cols="3" class='new-tag-column'>
                <b-button
                  v-if="!customer.customer.profile.isProfileIntakeSubmitted"
                  class="btn-danger btn-pill notification-btn-grid new-tag"
                  >New</b-button
                >
              </b-col>
              <b-col cols="2" class="actions-column">
                <div id="expand-icon-div"
                  class=""
                  v-if="!isOwnerUser"
                >
                  <div
                    class="archive-hover-avatar d-flex align-items-center justify-content-center"
                    v-if="
                      archiveHover &&
                        activeArchiveHoverId === customer.customer.profile.id
                    "
                    @click.stop="showArchiveModal(customer.customer.profile)"
                  >
                    <img src="@/assets/icons/arrow_down_square_hover.svg" alt="" />
                  </div>
                  <div v-else
                    class="empty-icon-avatar d-flex align-items-center justify-content-center"
                  >
                    <img
                      @click.stop="showArchiveModal(customer.customer.profile)"
                      src="@/assets/icons/arrow_down_square.svg"
                      alt
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        style="width:100%"
        spinner="spiral"
        @infinite="infiniteHandlerDedicatedCustomers"
        :identifier="infiniteId"
        ><div slot="no-more">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="primary--text font-family-medium mb-5 mt-5">
            No more customers to load.
          </h4>
        </div></infinite-loading
      >
    </b-row>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showArchive"
      v-if="showArchive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 v-if="isCustomerArchived" class="font-md modal_header ml-4">
            Successfully archived
          </h2>
          <h4 v-if="!isCustomerArchived" class="font-md subtext mb-4 mt-3 ml-4">
            Do you want to archive the following profile?
          </h4>
          <h4 v-else class="font-md subtext mb-4 mt-1 ml-4">
            Following customer has been successfully archived.
          </h4>
        </b-row>
        <b-row class="modal-main-content">
          <div class="mb-4 ml-4 info-wrapper">
            <div>
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div class="d-flex flex-column position-relative ml-4">
              <p class="font-family-medium primary--text">
                {{ selectedCustomerFullName }}
              </p>
              <p class="secondary--text reduce-whitespace">
                {{ selectedCustomerEmail }}
              </p>
              <div class="d-flex reduce-whitespace-2">
                <b-button
                  class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                  >{{ `Type - ${selectedSub}` }}</b-button
                >
              </div>
            </div>
          </div>
          <div class="button-wrapper"
            v-b-tooltip.hover :title="!selectedCustomer.endDate ? 'Please update End Date to enable archive.': ''"
          >
            <b-button
              @click="archiveCustomer"
              :disabled="!selectedCustomer.endDate"
              v-if="!isCustomerArchived"
              class="btn-primary px-5 py-3 btn-pill reduce-whitespace mr-5"
            >
              <b-spinner
                v-if="isSavingArchive"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${isSavingArchive ? "" : archiveBtnText}` }}
            </b-button>
          </div>
        </b-row>
        <b-row v-if="archiveError" class="archive-error">
          <b-col>
            {{ archiveError }}
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { getProfile } from "@/apis/auth/index";
import {
  archiveOrDeleteAccount,
  getAllArchivedOrDeletedAccounts,
  getAssistantCustomers,
  getCustomers
} from "@/apis/customers";
import { ellipsify, isOwner } from "@/utils/utils"
import { internalCustomerEmailSet } from "@/utils/constants";
export default {
  name: "DedicatedCustomers",
  methods: {
    ellipsify,
    navigate(customer) {
      if (customer.isProfileIntakeSubmitted) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: customer.id
          },
          query: {
            tab: 2
          }
        });
      } else {
        this.$router.push({
          name: "ClientIntake",
          params: {
            profileId: customer.id
          }
        });
      }
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
      this.activeArchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
      this.inactiveArchiveHoverId = id;
      this.archiveHover = false;
    },
    showArchiveModal(profile) {
      let { user, customerProfile } = profile;
      this.selectedCustomer = customerProfile
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showArchive = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
      this.selectedSub = customerProfile.membership;
    },
    getArchivedAccounts() {
      getAllArchivedOrDeletedAccounts().then(res => {
        let getArchiveDeleteForCurrentProfile = res.data.results.filter(
          item => item.profile === this.activeArchiveHoverId
        );
        if (getArchiveDeleteForCurrentProfile.length > 0) {
          this.isDelete = res.data.results
            .filter(item => {
              if (
                item.profile === this.activeArchiveHoverId &&
                !item.isDelete
              ) {
                return (
                  item.profile === this.activeArchiveHoverId &&
                  item.isDelete === false
                );
              }
            })
            .map(i => i.isDelete)[0];
        }
      });
    },
    archiveCustomer() {
      this.isSavingArchive = true;
      const data = {
        profile: this.activeArchiveHoverId,
        isDelete: false
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isSavingArchive = false;
          this.isCustomerArchived = true;
          this.customersList = this.customersList.filter(
            item => item.customer.profile.id !== this.activeArchiveHoverId
          );
        })
        .catch(err => {
          this.archiveError = err.response.data.detail
          this.isSavingArchive = false;
        });
    },
    closeModal() {
      this.showArchive = false;
      this.archiveError = null
      this.isCustomerArchived = false;
    },
    customerInitials(user) {
      let fullName = `${user.firstName} ${user.lastName}`;
      return fullName.match(/\b(\w)/g).join("");
    },
    customerFullName(user) {
      return `${user.firstName} ${user.lastName}`;
    },
    changeData() {
      this.customersList = [];
      this.offset = 0;
      this.infiniteId += 1;
      this.showListView = !this.showListView;
    },
    infiniteHandlerDedicatedCustomers($state) {
      const params = {
        customer__is_active: true,
        limit: 30,
        offset: this.offset
      };

      // Owners read the customer endpoint, which the API already scopes to
      // the customers assigned to them. Its rows are plain profiles, so
      // wrap them in the { customer: { profile } } shape this page renders.
      const request = this.isOwnerUser
        ? getCustomers({ is_active: true, limit: 30, offset: this.offset }).then(
            res => ({
              ...res,
              data: {
                ...res.data,
                results: res.data.results.map(profile => ({
                  customer: { profile }
                }))
              }
            })
          )
        : getAssistantCustomers(this.profileUserId, params);

      request
        .then(res => {
          this.loaded = true;
          this.customersList = [
            ...this.customersList,
            ...res.data.results
          ].filter(
            el => !internalCustomerEmailSet.has(el.customer.profile.user.email)
          );
          this.offset = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    ...mapState("authModule", ["role", "profileUserId"]),
    isOwnerUser() {
      return isOwner();
    }
  },
  data() {
    return {
      offset: 0,
      distance: Infinity,
      infiniteId: +new Date(),
      loaded: false,
      archiveError: null,
      isLoadingCustomers: true,
      showListView: false,
      isDedicated: false,
      isHandover: false,
      customersList: [],
      selectedSub: "",
      assistantProfileId: "",
      expandHover: false,
      archiveHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      activeArchiveHoverId: "",
      inactiveArchiveHoverId: "",
      showInactiveArchiveHover: true,
      showArchive: false,
      selectedCustomerFullName: "",
      selectedCustomerEmail: "",
      selectedCustomerAvatar: "",
      selectedCustomerInitials: "",
      selectedCustomer: {},
      isSavingArchive: false,
      isCustomerArchived: false,
      archiveBtnText: "Archive",
      isDelete: null,
      count: null
    };
  }
};
</script>

<style lang="scss" scoped>
.grid-list-wrapper {
  margin-bottom: 4rem;
}
.grid-list-card {
}
.grid-card,
.grid-list-card {
  cursor: pointer;
}
.grid-card:not(:last-child) {
  margin-right: 2%;
}
.grid-card:last-child {
  margin-right: 0;
}
.grid-icon-container {
  right: 0;
  bottom: 30%;
}
.grid-icon-container img {
  width: 21px;
  height: 21px;
}
.expand-right {
  right: 1.5rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.btn-align-top {
  top: -3.5rem;
}
.align-avatar-right {
  right: 1.3rem;
  bottom: 1rem;
}
.modal-main-content {
  display: flex;
  .info-wrapper {
    flex: 1;
    display: flex;
  }
  .button-wrapper {
    // flex: 1;
    margin: auto;
  }
}
.customer-data-wrapper {
  padding: 5px;
  p, div {
    padding: 5px 0;
    line-height: normal;
    margin: 0
  }
}
.grid-list-card-body {
  padding: 15px;
}
button.btn.btn-pill.new-tag {
  line-height: normal;
  padding: 6px 7px;
}
.grid-list-column {
  padding-bottom: 15px;
}
@media (min-width: 1200px) {
  .grid-list-column:nth-child(odd) {
    padding-right: 15px;
  }
  .grid-list-column:nth-child(even) {
    padding-left: 15px;
  }
  .heading-row {
    .col-xl-6 {
      padding-right: 15px;
    }
    .second-heading-column {
      padding-left: 15px;
    }  
  }
}
.actions-column {
  display: flex;
  >div {
    align-items: center;
    justify-content: flex-end;
    display: flex;
    flex: 1;
  }
}
.new-tag-column {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1199px) {
  .second-heading-column {
    display: none;
  }
}
@media (max-width: 576px) {
  .button-wrapper {
    padding: 20px 20px 20px 5px;
    text-align: center;
    margin-right: 0;
    button {
      margin-right: 0 !important;
    }
  }
}
</style>
